import { Theme } from '@mui/material/styles'

// ==============================|| OVERRIDES - ALERT TITLE ||============================== //

export default function Input(theme: Theme) {
  return {
    MuiInputBase: {
      defaultProps: {},
      styleOverrides: {
        root: {
          borderRadius: '6px!important',
        },
      },
    },
  }
}
